import React, { useEffect, useState } from "react";
import AsiaTeamCard from "../components/AsiaTeamCard";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { set } from "react-hook-form";
import team1 from "../assets/images/asg/1.png";
import team2 from "../assets/images/asg/2.png";

const AsiaTeam = () => {
  const [memberData, setMemberData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Hardcoded team data
  const staticData = [
    {
      id: "1",
      name: "K.V. Gururaja",
      designationId: 0,
      designationName: "",
      imgURL: team2,
      about:
        "Gururaja K. V. is a faculty member at Srishti Manipal Institute of Art, Design & Technology, Bengaluru, and holds the Dr T.M.A. Pai Endowment Chair in Anurans, Acoustics & Anthropogenic Climate Change. With an MSc and PhD in Environmental Sciences, his research focuses on amphibian ecology, bioacoustics, landscape ecology, and citizen science. He has discovered over 20 new frog species, authored Frogs and Toads of the Western Ghats, and developed the “Frog Find” app. His work links biodiversity conservation with technology and community participation.",
      link: "https://researcher.manipal.edu/en/persons/gururaja-k-v/",
      docLink: "",
    },
    {
      id: "2",
      name: "Dr. Barkha Subba",
      designationId: 1,
      designationName: "",
      imgURL: team1,
      about:
        "She is a conservation biologist and ecological restoration specialist whose work bridges science, communities, and policy in the Eastern Himalayas. With over a decade of experience in biodiversity conservation, she focuses on restoring degraded ecosystems and safeguarding threatened amphibians, particularly the Himalayan salamander (Tylototriton verrucosus). ",
      link: "",
      docLink: "/documents/barkha_subba.pdf",
    },
  ];
  // const initialDataFetch = async () => {
  //   await getDocs(collection(db, "members")).then((querySnapshot) => {
  //     const newData = querySnapshot.docs.map((doc) => ({
  //       ...doc.data(),
  //       id: doc.id,
  //     }));
  //     const filterData = [...newData]
  //       .filter((item) => item.type === 0)
  //       .sort((a, b) => a.designationId - b.designationId);

  //     setMemberData(filterData);
  //     setLoading(false);
  //   });
  // };
  useEffect(() => {
    setLoading(true);
    // initialDataFetch();
    setMemberData(staticData);
  }, []);

  return (
    <section id="team" class="team content-section">
      <div class="container justify-content-center text-align-center">
        {memberData.length > 0 ? (
          <>
            <div class="row justify-content-center">
              {memberData.map((data, index) => (
                <AsiaTeamCard
                  name={data.name}
                  position={data.designationName}
                  img={data.imgURL}
                  about={data.about}
                  link={data.link}
                  index={index}
                  docLink={data.docLink}
                />
              ))}
            </div>
          </>
        ) : (
          <p style={{ textAlign: "center" }}>No Data Available</p>
        )}
      </div>
    </section>
  );
};

export default AsiaTeam;

{
  /* <div class="container">
        <div class="row justify-content-center">
            <div className='col-md-12,col-sm-12 team-heading-container'>
                <h3 className='team-heading'>Staff</h3>
            </div>
          {team.map((data, index) => {
              if (data.type === 2) {
                return (
                  <TeamCard  name={data.name} position={data.position} img={data.img} about={data.about} email={data.email} year={data.year}/>
                );
              }
          })}
        </div>
      </div>
      <div class="container">
        <div class="row justify-content-center">
            <div className='col-md-12,col-sm-12 team-heading-container'>
                <h3 className='team-heading'>Post-doc</h3>
            </div>
          {team.map((data, index) => {
              if (data.type === 3) {
                return (
                  <TeamCard  name={data.name} position={data.position} img={data.img} about={data.about} email={data.email} year={data.year}/>
                );
              }
          })}
        </div>
      </div>
      <div class="container">
        <div class="row justify-content-center">
            <div className='col-md-12,col-sm-12 team-heading-container'>
                <h3 className='team-heading'>Graduate Students</h3>
            </div>
          {team.map((data, index) => {
              if (data.type === 4) {
                return (
                  <TeamCard  name={data.name} position={data.position} img={data.img} about={data.about} email={data.email} year={data.year}/>
                );
              }
          })}
        </div>
      </div>
      <div class="container">
        <div class="row justify-content-center">
            <div className='col-md-12,col-sm-12 team-heading-container'>
                <h3 className='team-heading'>Research Assistants</h3>
            </div>
          {team.map((data, index) => {
              if (data.type === 5) {
                return (
                  <TeamCard  name={data.name} position={data.position} img={data.img} about={data.about} email={data.email} year={data.year}/>
                );
              }
          })}
        </div>
      </div> */
}
